import { Link } from "react-router-dom";

interface CategoryEntryProps {
  movieCount: number;
  tvCount: number;
}

export default function CategoryEntry({ movieCount, tvCount }: CategoryEntryProps) {
  const entries = [
    {
      to: "/movies",
      icon: "ri-movie-2-line",
      title: "电影专区",
      desc: "动作、科幻、悬疑、爱情……海量热门电影随心浏览",
      count: movieCount,
    },
    {
      to: "/tvshows",
      icon: "ri-tv-2-line",
      title: "电视剧专区",
      desc: "古装、都市、犯罪、家庭……热播剧集一网打尽",
      count: tvCount,
    },
  ];

  return (
    <section className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group relative overflow-hidden rounded-lg border border-background-200/60 bg-background-100/60 p-5 transition-colors duration-200 hover:border-primary-400/70 md:p-7"
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <span className="flex h-14 w-14 items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 md:h-16 md:w-16">
                  <i className={`${entry.icon} text-2xl md:text-3xl`}></i>
                </span>
                <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  {entry.title}
                </h3>
                <p className="mt-2 max-w-xs text-sm leading-relaxed text-foreground-600">
                  {entry.desc}
                </p>
              </div>
              <span className="shrink-0 rounded-full bg-secondary-100/80 px-3 py-1 text-xs font-medium text-secondary-900">
                {entry.count}+ 部
              </span>
            </div>
            <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-primary-500">
              进入专区
              <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}